/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import InitiateApiCalls from "./InitiateApiCalls.container";

export default InitiateApiCalls;
